/* eslint-disable react/no-danger */
/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";

const NumericQuestion = ({
  question,
  selectedAnswer,
  currentIndex,
  onSelect,
}) => {
  const [inputValue, setInputValue] = useState(selectedAnswer || "");

  useEffect(() => {
    setInputValue(selectedAnswer || "");
  }, [selectedAnswer]);

  const handleKeyPress = (key) => {
    if (key === "Clear") {
      setInputValue("");
      onSelect("");
      return;
    }

    if (key === "backspace") {
      const newValue = inputValue.slice(0, -1);
      setInputValue(newValue);
      onSelect(newValue);
      return;
    }
    if (key === "-") {
      let newValue;
      if (inputValue.startsWith("-")) {
        newValue = inputValue.substring(1);
      } else {
        newValue = `-${inputValue}`;
      }
      setInputValue(newValue);
      onSelect(newValue);
      return;
    }

    if (key === "." && inputValue === "") {
      const newValue = "0.";
      setInputValue(newValue);
      onSelect(newValue);
      return;
    }

    if (key === "." && inputValue === "-") {
      const newValue = "-0.";
      setInputValue(newValue);
      onSelect(newValue);
      return;
    }

    if (key === "." && inputValue.includes(".")) {
      return;
    }

    const newValue = `${inputValue}${key}`;
    setInputValue(newValue);
    onSelect(newValue);
  };

  const numpadKeys = [
    ["1", "2", "3"],
    ["4", "5", "6"],
    ["7", "8", "9"],
    ["-", "0", "."],
    ["Clear", "⌫"],
  ];

  return (
    <div className="mx-auto" style={{ padding: "16px 20px" }}>
      {/* Header */}
      <div
        className="flex items-center gap-[12px] mb-[16px]"
        style={{
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        <span
          className="text-[17px] font-bold text-[#111827]"
          style={{
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          Question {currentIndex + 1}
        </span>
        <span
          className="px-[12px] py-[4px] border-[1.5px] border-[#60a5fa] rounded-[6px] text-[11px] font-bold uppercase text-[#2563eb]"
          style={{
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          NUMERIC
        </span>
     
      </div>

      <div
        className="mb-8"
        style={{
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
        dangerouslySetInnerHTML={{ __html: question?.question_text }}
      />

      <div className="flex justify-center mb-3">
        <div
          className="w-[248px] px-[20px] text-center flex items-center justify-center h-[56px]"
          style={{
            backgroundColor: "#eff6ff",
            border: "2px solid #3b82f6",
            borderRadius: "12px",
            height: "56px",
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          <span
            className="text-[24px] font-semibold text-[#111827] leading-none"
            style={{
              letterSpacing: "0.02em",
              fontFamily: "system-ui, -apple-system, sans-serif",
            }}
          >
            {inputValue || ""}
          </span>
        </div>
      </div>

      {/* Numpad */}
      <div className="flex flex-col gap-[12px] items-center">
        {numpadKeys.map((row, rowIndex) => (
          <div key={rowIndex} className="flex gap-[12px]">
            {row.map((key) => (
              <button
                key={key}
                onClick={() => {
                  if (key === "⌫") {
                    handleKeyPress("backspace");
                  } else {
                    handleKeyPress(key);
                  }
                }}
                style={{
                  width: "72px",
                  height: "56px",
                  borderRadius: "10px",
                  border: "1.5px solid #e5e7eb",
                  backgroundColor: "#ffffff",
                  color: key === "⌫" ? "#6b7280" : "#111827",
                  fontSize: "20px",
                  fontWeight: 500,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.15s ease",
                  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                  fontFamily: "system-ui, -apple-system, sans-serif",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#f9fafb";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#ffffff";
                }}
                onMouseDown={(e) => {
                  e.target.style.transform = "scale(0.96)";
                }}
                onMouseUp={(e) => {
                  e.target.style.transform = "scale(1)";
                }}
              >
                {key}
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NumericQuestion;